import imageLoyalty from '../../Images/About/loyalty.svg'
import imageIntegrity from '../../Images/About/integrity.svg'
import imageDecisiveness from '../../Images/About/decisiveness.svg'
import imageHonestpay from '../../Images/About/honestpay.svg'
import '../../Styles/Sass/OurValues.scss';

function OurValues() {
  return (
    <section className='ourValues'>
    	<h2 className='ourValues__title'>Our Values</h2>
    	<ul className='ourValues__list'>
    		<li className='ourCard'>
    			<img className='ourCard__image' src={imageLoyalty} alt="" />
    			<h3 className='ourCard__title'>Loyalty</h3>
    			<p className='ourCard__description'>Clean Connection stands by you providing the tool box to ensure you have what you need to meet your goals. </p>
    		</li>
    		<li className='ourCard'>
    			<img className='ourCard__image ourCard__image--integrity' src={imageIntegrity} alt="" />
    			<h3 className='ourCard__title'>Integrity</h3>
    			<p className='ourCard__description'>We firmly believe in offering our members the tools to share integral information that provides confidence through endorsed industry peer and client reviews</p>
    		</li>
    		<li className='ourCard'>
    			<img className='ourCard__image' src={imageDecisiveness} alt="" />
    			<h3 className='ourCard__title'>Decisiveness</h3>
    			<p className='ourCard__description'>Clean Connection cuts away indecisiveness with client and peer reviews, certifications, record checks allowing for a clear path to the call to action.</p>
    		</li>
    		<li className='ourCard'>
    			<img className='ourCard__image ourCard__image--honestpay' src={imageHonestpay} alt="" />
    			<h3 className='ourCard__title'>Honest Pay</h3>
    			<p className='ourCard__description'>While each job post will have its own rate of pay, Ontario minimum wage is not supported. The minimum rate must be above $16 per hour.</p>
    		</li>
    	</ul>
    </section>
  );
}

export default OurValues;
